package styles

import org.jetbrains.compose.web.css.*

object GlobalStyles : StyleSheet() {
    init {
        // CSS Reset
        "*, *::before, *::after" style {
            property("box-sizing", "border-box")
            property("border", "0 solid")
        }

        "html" style {
            property("-webkit-text-size-adjust", "100%")
            property("tab-size", "4")
        }

        "body" style {
            property("margin", "0")
            property("font-family", "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif")
            property("line-height", "1.5")
            property("background-color", "var(--background)")
            property("color", "var(--on-surface)")
            property("transition", "background-color 0.3s ease, color 0.3s ease")
            property("-webkit-font-smoothing", "antialiased")
        }

        "*" style {
            property("font-family", "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif")
        }

        "a" style {
            property("text-decoration", "none")
            property("color", "inherit")
        }

        "h1, h2, h3, h4, h5, h6" style {
            property("margin", "0")
        }

        "p" style {
            property("margin", "0")
        }

        "ul, ol" style {
            property("margin", "0")
            property("padding", "0")
            property("list-style", "none")
        }

        "button" style {
            property("font-family", "inherit")
        }

        // CSS variables - Light theme
        ":root" style {
            // Primary
            property("--primary", "#BD0C23")
            property("--on-primary", "#FFFFFF")
            property("--primary-container", "#D30C25")
            property("--on-primary-container", "#670008")

            // Secondary
            property("--secondary", "#F8E544")
            property("--on-secondary", "#0C0C0C")

            // Surface & Background
            property("--background", "#FFFFFF")
            property("--on-background", "#AAAAAA")
            property("--surface", "#FFE7E7")
            property("--on-surface", "#1B1A1A")
            property("--surface-variant", "#666666")
            property("--on-surface-variant", "#534342")

            // Surface containers
            property("--surface-container", "#F5F5F5")
            property("--surface-container-high", "#FAFAFA")
            property("--surface-container-lowest", "#FFFFFF")

            // Outline
            property("--outline", "#444444")
            property("--outline-variant", "#E4CECC")

            // Shadows
            property("--shadow-sm", "0 1px 3px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.03)")
            property("--shadow-md", "0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.04)")
            property("--shadow-lg", "0 4px 20px rgba(0, 0, 0, 0.08), 0 8px 32px rgba(0, 0, 0, 0.05)")
            property("--scrim", "rgba(0, 0, 0, 0.6)")

            // Shapes
            property("--shape-extra-small", "4px")
            property("--shape-small", "6px")
            property("--shape-medium", "8px")
            property("--shape-large", "12px")
            property("--shape-extra-large", "16px")

            // Error / Success
            property("--error", "#B3261E")
            property("--success", "#22c55e")
        }

        // CSS variables - Dark theme
        ":root.dark" style {
            property("--primary", "#BD0C23")
            property("--on-primary", "#FFFFFF")
            property("--primary-container", "#D30C25")
            property("--on-primary-container", "#FFDAD7")

            property("--secondary", "#DBC826")
            property("--on-secondary", "#0C0C0C")

            property("--background", "#1B1A1A")
            property("--on-background", "#555555")
            property("--surface", "#341010")
            property("--on-surface", "#FFFFFF")
            property("--surface-variant", "#B3B3B3")
            property("--on-surface-variant", "#D8C2C0")

            property("--surface-container", "#2A2020")
            property("--surface-container-high", "#3A2828")
            property("--surface-container-lowest", "#1F1515")

            property("--outline", "#E6E6E6")
            property("--outline-variant", "#524947")

            property("--shadow-sm", "0 1px 3px rgba(255, 255, 255, 0.04), 0 2px 6px rgba(255, 255, 255, 0.02)")
            property("--shadow-md", "0 2px 8px rgba(255, 255, 255, 0.06), 0 4px 16px rgba(255, 255, 255, 0.03)")
            property("--shadow-lg", "0 4px 20px rgba(255, 255, 255, 0.08), 0 8px 32px rgba(255, 255, 255, 0.04)")

            property("--success", "#4ade80")
        }

        // 404 page hover effects
        ".not-found-page__button:hover" style {
            opacity(0.85)
        }

        ".not-found-page__link-card:hover" style {
            property("border-color", "var(--primary)")
            property("transform", "translateY(-2px)")
        }
    }
}
